import React, { Component } from 'react';
import urlHandler from '../../../utils/urlHandler';

class DocV2EntitiesDelete extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Delete Entities</h3>
                <code className="api-definition">
                    <span className="delete-badge">DELETE</span>&nbsp;{urlHandler.API_ENDPOINT_V2_ENTITIES}/{'{'}id{'}'}
                </code>
                <div className="description">
                    <b>Delete Knowledgebase Entity</b><br/>
                    <br/>
                    The entities DELETE request deletes an existing entity with the <i>entity_id</i> provided from the 
                    appropriate knowledgebase. A successful request returns a status code 204 (HTTP No Content.) 

                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                </div>

                <h4 className="heading-2">Request</h4>

                <h4 className="heading-3"> URL Parameters</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">The Finch identifier for entity to delete.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        DELETE {urlHandler.API_ENDPOINT_V2_ENTITIES}/1234567890<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                    </pre>
                </div>

                <h4 className="heading-2">Error Responses</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Code </th>
                        <th>Status Text </th>
                        <th>Description </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">404</td>
                        <td className="status-text">Not Found</td>
                        <td className="notes">Entity not found (another client deleted it).
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">423</td>
                        <td className="status-text">Locked</td>
                        <td className="notes">Indicates that the entity was in the process of being updated or deleted 
                            when the request was received.
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default DocV2EntitiesDelete;